export const makeWarningMessage = (title) =>
  `Any information you have added to ${"<" + title + ">"} will be discarded.`;
